import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-24" }
const _hoisted_2 = { class: "flex items-center justify-center font-bold text-40px lg:text-7xl text-white text-center font-sarabun py-16 lg:py-28" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Annual Reports", -1)
const _hoisted_5 = {
  key: 0,
  class: "py-24 px-6 mb-40"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "mx-auto",
  src: "/images/annual-reporter-empty.svg"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-8 text-gray-600" }, " Annual Reports not found. ", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["onClick"]

import { useRoute } from 'vue-router';
import { onMounted, ref, computed } from 'vue';
import * as api from '@/apis/forest';
import { AnnualReportEntities, File } from '@/types/Forest';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const report = ref<AnnualReportEntities[]>();
const forestName = ref<string>();

onMounted(async () => {
  const getApi =
    isForestReport.value != 0
      ? api.getAnnualReportForest(isForestReport.value)
      : api.getAnnualReport();

  const res = await getApi;
  report.value = res.data.entities;

  if (isForestReport.value != 0) {
    forestName.value = report.value[0].name;
  }
});

const isForestReport = computed(() => {
  const idForest = route.params.id ? parseInt(route.params.id as string) : 0;
  return idForest;
});

const downloadReport = (file: File) => {
  window.open(file.original_image_url);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(`background: url(${
        _unref(isForestReport)
          ? '/images/report/reportForestHeader.webp'
          : '/images/report/reportHeader.webp'
      });`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(isForestReport))
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(forestName.value), 1))
          : _createCommentVNode("", true),
        _hoisted_4
      ])
    ], 4),
    (!report.value?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.value, (r, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex flex-wrap border-b container mx-auto px-6 pb-5 mt-11 items-center",
              key: i
            }, [
              _createElementVNode("img", {
                class: "w-full lg:w-1/2",
                src: r.image.original_image_url,
                alt: ""
              }, null, 8, _hoisted_10),
              _createElementVNode("div", {
                class: "w-full lg:w-1/2 text-2xl pt-4 px-4 font-semibold text-primary-dark underline cursor-pointer text-center lg:text-left",
                onClick: ($event: any) => (downloadReport(r.file))
              }, _toDisplayString(r.name) + " " + _toDisplayString(r.year), 9, _hoisted_11)
            ]))
          }), 128))
        ]))
  ]))
}
}

})